import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';

import ValidationError from '../../components/ValidationError/ValidationError';
import StringInput from '../../components/Input/StringInput/StringInput';
import Button from '../../components/Button/Button';

import Select from '../../components/Input/Select/Select';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import { formValidation } from '../../hoc/Shared/utility';

import * as actions from '../../store/ducks/rejectReason/actions';

const initialFormInputState =
{
    /* form input value */
    title: '',
    transaction_type: '',
};

class RejectReasonCreate extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            formFilter: initialFormInputState,
            dropDown:
            {
                transactionType: [],
            },
            loading: true,
            errMsg: [],
            touched: false,
        }
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
        // console.log('componentDidMount (create):', this.state);
        this.props.funcGetDropDown(); // get filter drop down
        formValidation('reject_reason_form');
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextProps.store !== this.props.store && nextProps.store !== undefined) {
            // console.log('shouldComponentUpdate (create):', nextProps.store);
            let success = (nextProps.store.responseCode === 200 && nextProps.store.msgType === 'success') ? true : false;
            if (nextProps.store.responseCode === 200 && nextProps.store.msgType === 'success') {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-saved'),
                    showConfirmButton: true
                }).then(() => {
                    this.props.refreshHandler();
                    this.props.changePageHandler('listing');
                });
            }
            else {
                this.setState({
                    touched: (success) ? false : true,
                    errMsg: (success) ? [] : nextProps.store.message
                });
                Swal.close();
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined) {
            if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === 'success') {
                this.setState({
                    dropDown:
                    {
                        transactionType: nextProps.dropDown.data.transaction_type,
                    }
                });
            }
        }

        return true;
    }

    loadingHandler = () => {
        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    }

    onInputChange = (event, id) => {
        // console.log(event.target.id+' | '+event.target.value);
        let newInput = Object.assign({}, this.state.formFilter);
        newInput[event.target.id] = event.target.value;
        this.setState({
            formFilter: newInput
        });
    }

    submitHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;

        Swal.fire({
            title: t('validation.confirmation'),
            text: t('validation.confirmation_check'),
            icon: 'warning',
            confirmButtonText: t('global.save'),
            showDenyButton: true,
            denyButtonText: t('global.cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                });
                const inputArr = {};
                Object.keys(this.state.formFilter).forEach((val) => {
                    inputArr[val] = this.state.formFilter[val];
                });
                // console.log(inputArr);
                this.props.funcStore(inputArr);
            }
        });
    }

    render() {
        const { t } = this.props;
        let inputArr = (this.state.formFilter) ? this.state.formFilter : [];
        let permission = (this.props.currentUser.permission) ? this.props.currentUser.permission : [];
        // console.log(this.state.dropDown.transactionType);

        return (
            <Auxiliary>
                <div className='breadcrumb-header'>
                    <div className='d-flex'>
                        <div className='my-auto'>
                            <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler('listing')} />
                        </div>
                    </div>
                    <div className='my-auto'>
                        <div className='d-flex'>
                            <h4 className='content-title mb-0 my-auto ml-2'>{t('reject-reason.title')}</h4>
                        </div>
                    </div>
                </div>
                <div className='row row-sm'>
                    <div className='col-12'>
                        <div className='card  box-shadow-0'>
                            <div className='card-header'>
                                <h4 className='card-title mb-1'>{t('role.reject_reason_create')}</h4>
                            </div>

                            <div className='card-body pt-0'>
                                <form method='post' id='reject_reason_form' className='form-horizontal' onSubmit={this.submitHandler} noValidate>
                                    <ValidationError formName='reject_reason_form' touched={this.state.touched} message={this.state.errMsg} />
                                    <div className='row'>
                                        <div className='col-md-6 col-12 form-group'>
                                            <label htmlFor='title'>{t('reject-reason._title')}</label>
                                            <StringInput
                                                id='title'
                                                name='title'
                                                placeholder={t('reject-reason._title')}
                                                value={inputArr.title || ''}
                                                onChange={(event) => this.onInputChange(event)}
                                                required
                                            />
                                        </div>

                                        <div className='col-md-6 col-12  form-group'>
                                            <label htmlFor='transaction_type'>{t('transaction.transaction-type')}</label>
                                            <Select
                                                id='transaction_type'
                                                name='transaction_type'
                                                className='form-control filter-input'
                                                getOptionValue='id'
                                                getOptionLabel='title'
                                                options={this.state.dropDown.transactionType}
                                                onChange={this.onInputChange}
                                                value={this.state.formFilter.transaction_type || ''}
                                                emptyValue={true}
                                                required
                                            />
                                        </div>

                                        <div className='col-12 form-group mb-0 justify-content-end'>
                                            <div>
                                                {(permission.includes('reject_reason_create')) &&
                                                    <Button typeButton='submit' classValue='btn btn-blue' idValue='save' buttonName={t('global.save')} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    return {
        store: state.rejectReason.store,
        dropDown: state.rejectReason.dropDown,
        currentUser: state.currentUser.data,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => {
    return {
        funcStore: (data) => dispatch(actions.store(data)),
        funcGetDropDown: () => dispatch(actions.getDropDown()),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(RejectReasonCreate));